import { Component, OnInit, NgZone } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';

import { Observable, BehaviorSubject } from 'rxjs/Rx';
import'rxjs/add/operator/debounceTime';

// import {Product } from '../products/product';
// import { CartItem } from '../cart/cart-item';

import { CartService } from '../cart/cart.service';
import { CheckoutService } from './checkout.service';
import { SalesTaxService } from '../sales-tax/sales-tax.service';
import { State } from '../states/state';
import { StatesService } from '../states/states.service';
import { OrderConfirmationService } from '../order-confirmation/order-confirmation.service';
import { OrderConfirmationInfo } from '../order-confirmation/order-confirmation-info';
import { LoggingService } from '../loging/logging.service';
export class CheckoutComponent implements OnInit {
    salesTaxRate: Observable<number>;
    countyChanges: Observable<string>;
    countyControl: FormControl = new FormControl('', Validators.required);
    selectedState: BehaviorSubject<string> = new BehaviorSubject<string>('undefined');
    stateSelectElement: HTMLSelectElement;
    stateSelectElementChanges: Observable<string>;
    states: Observable<State[]>;
    counties: Observable<string[]>;
    validationErrors: BehaviorSubject<object> = new BehaviorSubject<object>(null);
/**
 * @param {?} cartService
 * @param {?} location
 * @param {?} checkoutService
 * @param {?} salesTaxService
 * @param {?} statesService
 * @param {?} router
 * @param {?} orderConfirmationService
 * @param {?} zone
 * @param {?} loggingService
 */
constructor(
private cartService: CartService,
private location: Location,
private checkoutService: CheckoutService,
private salesTaxService: SalesTaxService,
private statesService: StatesService,
private router: Router,
private orderConfirmationService: OrderConfirmationService,
private zone: NgZone,
private loggingService: LoggingService
    ) {
    }
/**
 * @return {?}
 */
ngOnInit() {

        this.states = this.statesService.getStates();
        this.counties =
            this.salesTaxService.getCountyTaxRates()
                .flatMap(countyTaxRates => Observable.from(countyTaxRates))
                .map(countyTaxRate => countyTaxRate.county)
                .distinct()
                .toArray();

        this.stateSelectElement = /** @type {?} */(( <HTMLSelectElement>document.getElementById('address_state')));

        this.stateSelectElementChanges = Observable.fromEvent(
            this.stateSelectElement, 'change'
        );

        this.stateSelectElementChanges.subscribe(
            event => this.onStateChanged(event));

        this.loggingService.log('checkout.component.ts: salesTaxService <below>')
        this.loggingService.log(this.salesTaxService);

        // this.salesTaxService.getCountyTaxRate(this.checkoutService.checkoutInfo.address_county).subscribe(
        //     (taxrate) =>
        //     {
        //         alert('taxrate = ' + taxrate);
        //         this.checkoutService.checkoutInfo.sales_tax_rate = taxrate;
        //     });

        // this.countyControl = <HTMLInputElement>document.getElementById('address_county');

        this.loggingService.log('this.countyControl = ' + JSON.stringify(this.countyControl));

        this.countyChanges = this.countyControl.valueChanges.debounceTime(500);

        this.loggingService.log('this.countyChanges = ' + JSON.stringify(this.countyChanges));

        this.countyChanges
            .combineLatest(
            this.selectedState.asObservable(),
            (
                nextCounty: string,
                selectedState
            ) => {
                return {
                    county: nextCounty,
                    state: selectedState
                };
            })
            .subscribe((latest) => {

                this.loggingService.log('latest.county = ' + latest.county);
                this.loggingService.log('latest.state = ' + latest.state);

                this.checkoutService.checkoutInfo.address_county = latest.county;

                this.checkoutService.checkoutInfo.address_state = latest.state;

                this.salesTaxRate =
                    this.salesTaxService.getCountyTaxRate(latest.county)
                        .withLatestFrom(this.selectedState)
                        .map(([taxRate, selectedState]) => selectedState == 'FL' ? taxRate + 6 : 0);


                this.salesTaxRate.subscribe((nextRate) => {

                    this.loggingService.log('nextRate = ' + nextRate);
                    this.checkoutService.checkoutInfo.sales_tax_rate = nextRate;

                    this.checkoutService.updateTotals()

                })
            });

    }
/**
 * @return {?}
 */
goBack(): void {
        this.location.back();
    }
/**
 * @return {?}
 */
getCreditCardToken(): void {
        this.validationErrors.next(null);
        this.checkoutService.setShippingAddress();

        this.checkoutService.getCreditCardToken(this.checkoutService.checkoutInfo).subscribe(
            (next) => {
                this.loggingService.log('next = ' + JSON.stringify(next));
                if (next.error) {
                    this.zone.run(() => this.validationErrors.next({message: next.error.message}));
                } else {
                    this.checkoutService.checkoutInfo.cardToken = next.id;
                    this.checkoutService.createCharge(this.checkoutService.checkoutInfo).subscribe(
                        (nextCheckoutInfo) => {
                            this.loggingService.log('checkout.component.ts:getCreditCardToken nextCheckoutInfo = ' + nextCheckoutInfo);
                            // this.loggingService.log('checkout.component.ts:getCreditCardToken next = ' + next());
                        },
                        (err) => {
                            this.loggingService.log('create charge err = ' + err);

                            let /** @type {?} */ errorBody = JSON.parse(err._body);
                            if (errorBody.message) {
                                if (errorBody.validationErrors) {
                                    errorBody.validationErrors['message'] = errorBody.message;
                                } else {
                                    errorBody.validationErrors = { message: errorBody.message };
                                }
                            }
                            if (errorBody.validationErrors) {
                                this.zone.run(() => this.validationErrors.next(errorBody.validationErrors));
                            }
                        },
                        () => {
                            this.loggingService.log('create charge completed');

                            let /** @type {?} */ orderConfirmationInfo: OrderConfirmationInfo = new OrderConfirmationInfo();
                            orderConfirmationInfo.cartItems = this.cartService.cartItems.slice(0);
                            orderConfirmationInfo.grand_total = this.checkoutService.checkoutInfo.grand_total;
                            orderConfirmationInfo.sales_tax = this.checkoutService.checkoutInfo.sales_tax;
                            orderConfirmationInfo.shipping_cost = this.checkoutService.checkoutInfo.shipping_cost;
                            orderConfirmationInfo.total_after_tax = this.checkoutService.checkoutInfo.total_after_tax;
                            orderConfirmationInfo.total_before_tax = this.checkoutService.checkoutInfo.total_before_tax;

                            this.orderConfirmationService.orderConfirmationInfo = orderConfirmationInfo;

                            this.cartService.clear();
                            this.checkoutService.checkoutInfo.cardToken = null;
                            //this.router.navigate(['order-confirmation']);
                            document.getElementById('global-order-confirmation-link').click();
                        }
                    );
                }
            },
            (err) => {
                this.loggingService.log('err = ' + JSON.stringify(err));

                let /** @type {?} */ errorBody = JSON.parse(err._body);
                if (errorBody.validationErrors) {
                    this.zone.run(() => this.validationErrors.next(errorBody.validationErrors));
                }
            },
            () => {
                this.loggingService.log('completing');
            }
        );
    }
/**
 * @param {?} event
 * @return {?}
 */
onStateChanged(event: any) {
        this.selectedState.next(event.target.value);
    }
/**
 * @return {?}
 */
viewOrderSummary(): void {
        this.router.navigate(['/order-summary']);
    }
/**
 * @param {?} jsonObject
 * @return {?}
 */
stringify(jsonObject: object): string {
        return JSON.stringify(jsonObject);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-checkout',
    template: "﻿<div class=\"main-checkout-div\"> <h2>Checkout</h2> <!--<ul class=\"cart-items\"> <li *ngFor=\"let cartItem of cartItems\"> <span>{{cartItem.product.name}} ${{cartItem.product.price}} Qty:{{cartItem.quantity}} SubTotal:{{cartItem.quantity * cartItem.product.price}}</span><button (click)=\"removeProduct(cartItem.index)\" style=\"font-weight:bold\">X</button> </li> </ul> <span style=\"font-weight:bold;font-style:italic\">Total Before Tax:{{cartGrandTotal}}</span><br /> <span style=\"font-size:smaller;font-style:italic\">Taxes will be calculated based on your address after you enter shipping information.</span><br /> <button (click)=\"goBack()\">Back</button> <button (click)=\"checkout()\">(C|c)heckout</button>--> <form #f=\"ngForm\" novalidate> <div class=\"checkout-div\"> <label for=\"amount\">Order Subtotal</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.total_before_tax\" type=\"text\" id=\"grandTotal\" name=\"grandTotal\"> <br /> <label for=\"shipping_cost\">Shipping</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.shipping_cost\" type=\"text\" id=\"shipping_cost\" name=\"shipping_cost\"> <br /> <label for=\"nameoncard\">Name on Card</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.nameoncard\" type=\"text\" id=\"nameoncard\" name=\"nameoncard\" autocomplete=\"cc-name\" #nameoncard=\"ngModel\" required> <br /> <label for=\"ccnumber\">Credit Card Number</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.ccnumber\" type=\"text\" id=\"ccnumber\" name=\"ccnumber\" autocomplete=\"cc-number\" #ccnumber=\"ngModel\" required minlength=\"12\" maxlength=\"19\" /> <br /> <label for=\"cc-exp-month\">Expiration Month</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.ccexpmonth\" type=\"number\" id=\"cc-exp-month\" name=\"cc-exp-month\" autocomplete=\"cc-exp-month\" #ccExpMonth=\"ngModel\" required> <br /> <label for=\"cc-exp-year\">Expiration Year</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.ccexpyear\" type=\"number\" id=\"cc-exp-year\" name=\"cc-exp-year\" autocomplete=\"cc-exp-year\" #ccExpYear=\"ngModel\" required> <br /> <label for=\"cvv2\">CVV</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.ccv2\" type=\"text\" id=\"cvv2\" name=\"cvv2\" autocomplete=\"cc-csc\" #cvv2=\"ngModel\" required> <br /> <label for=\"address_line1\">Address Line 1</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.address_line1\" type=\"text\" id=\"address_line1\" name=\"address_line1\" autocomplete=\"address-line1\" #addressLine1=\"ngModel\" required> <br /> <label for=\"address_line2\">Address Line 2</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.address_line2\" type=\"text\" id=\"address_line2\" name=\"address_line2\" autocomplete=\"address-line2\"> <br /> <label for=\"address_state\">City</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.address_city\" type=\"text\" id=\"address_city\" name=\"address_city\" autocomplete=\"address-city\" #addressCity=\"ngModel\" required> <br /> <div style=\"display:inline-block;text-align:left\"> <div style=\"display:inline-block\"> <label for=\"address_state\">State</label> </div> <div style=\"display:inline-block;text-align:left\"> <select [(ngModel)]=\"checkoutService.checkoutInfo.address_state\" id=\"address_state\" name=\"address_state\" autocomplete=\"address_state\" #addressState=\"ngModel\" required> <option *ngFor=\"let state of (states | async)\" id=\"state_option_{{state.abbreviation}}\" value=\"{{state.abbreviation}}\">{{state.abbreviation}}</option> </select> </div> </div> <br /> <div [hidden]=\"checkoutService.checkoutInfo.address_state != 'FL'\"> <label for=\"county\">County</label> <!-- <input *ngIf=\"checkoutService.checkoutInfo.address_state != 'FL'\" [formControl]=\"countyControl\" [(ngModel)]=\"checkoutService.checkoutInfo.address_county\" type=\"text\" id=\"address_county\" name=\"address_county\" autocomplete=\"county\"> --> <select [formControl]=\"countyControl\" [(ngModel)]=\"checkoutService.checkoutInfo.address_county\" id=\"address_county\" name=\"address_county\" autocomplete=\"county\"> <option *ngFor=\"let county of (counties | async)\" value=\"{{county}}\">{{county}}</option> </select> <br /> </div> <label for=\"address_zip\">Zip</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.address_zip\" type=\"text\" id=\"address_zip\" name=\"address_zip\" autocomplete=\"postal-code\" #addressZip=\"ngModel\" required> <br /> <label for=\"country\">Country</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.address_country\" type=\"text\" id=\"address_country\" name=\"address_country\" autocomplete=\"country\" #addressCounty=\"ngModel\" required> <br /> <label for=\"address_email\">Email</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.address_email\" type=\"text\" id=\"address_email\" name=\"address_email\" autocomplete=\"email\"> <br /> <label for=\"address_phone\">Phone</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.address_phone\" type=\"text\" id=\"address_phone\" name=\"address_phone\" autocomplete=\"phone\"> <br /> <!-- <label for=\"mail_class\">Mail Class</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.mail_class\" type=\"text\" id=\"mail_class\" name=\"mail_class\" autocomplete=\"mail_class\"> <br /> --> <label for=\"sales_tax_rate\">Sales Tax %</label> <input [(ngModel)]=\"checkoutService.checkoutInfo.sales_tax_rate\" type=\"text\" id=\"sales_tax_rate\" name=\"sales_tax_rate\" autocomplete=\"sales_tax_rate\" disabled> </div> <br *ngIf=\"f.valid\"/> <div *ngIf=\"nameoncard.invalid && (nameoncard.dirty || nameoncard.touched)\" class=\"warning-text\"> <small *ngIf=\"nameoncard.errors.required\">Name on Card is required.</small> </div> <div *ngIf=\"ccnumber.invalid && (ccnumber.dirty || ccnumber.touched)\" class=\"warning-text\"> <small *ngIf=\"ccnumber.errors.required\" [hidden]=\"ccnumber.valid || (ccnumber.pristine && !f.submitted)\">Credit card Number is required.</small> <small *ngIf=\"ccnumber.errors.minlength\">Credit Card Number must be at least 12 characters</small> </div> <div *ngIf=\"ccExpMonth.invalid && (ccExpMonth.dirty || ccExpMonth.touched)\" class=\"warning-text\"> <small *ngIf=\"ccExpMonth.errors.required\">Credit Card Expiration Date is required.</small> </div> <div *ngIf=\"ccExpYear.invalid && (ccExpYear.dirty || ccExpYear.touched)\" class=\"warning-text\"> <small *ngIf=\"ccExpYear.errors.required\">Credit Card Expiration Year is required.</small> </div> <div *ngIf=\"cvv2.invalid && (cvv2.dirty || cvv2.touched)\" class=\"warning-text\"> <small *ngIf=\"cvv2.errors.required\">Credit Card CVV code is required.</small> </div> <div *ngIf=\"addressLine1.invalid && (addressLine1.dirty || addressLine1.touched)\" class=\"warning-text\"> <small *ngIf=\"addressLine1.errors.required\">Address Line 1 is required.</small> </div> <div *ngIf=\"addressCity.invalid && (addressCity.dirty || addressCity.touched)\" class=\"warning-text\"> <small *ngIf=\"addressCity.errors.required\">City is required.</small> </div> <div *ngIf=\"addressState.invalid\" class=\"warning-text\"> <small *ngIf=\"addressState.errors.required\">State is required.</small> </div> <div *ngIf=\"addressZip.invalid && (addressZip.dirty || addressZip.touched)\" class=\"warning-text\"> <small *ngIf=\"addressZip.errors.required\">City is required.</small> </div> <div *ngIf=\"validationErrors | async\" class=\"warning-text\"> <div *ngIf=\"(validationErrors | async).nameOnCardError\">{{(validationErrors | async).nameOnCardError}}</div> <div *ngIf=\"(validationErrors | async).zipError\">{{(validationErrors | async).zipError}}</div> <div *ngIf=\"(validationErrors | async).message\">{{(validationErrors | async).message}}</div> </div> <button [hidden]=\"!f.valid\" (click)=\"viewOrderSummary()\">View Order Summary</button> <button [hidden]=\"!f.valid\" (click)=\"getCreditCardToken()\">Submit Order</button> </form> </div>",
    styles: ["﻿.checkout-div{ text-align: right; padding-right: 1em; width: 22em; } input{ width:11em; } select{ width:11em; } .main-checkout-div{ align-content: center; } .warning-text{ color: red; font-size: small; }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CartService, },
{type: Location, },
{type: CheckoutService, },
{type: SalesTaxService, },
{type: StatesService, },
{type: Router, },
{type: OrderConfirmationService, },
{type: NgZone, },
{type: LoggingService, },
];
}

function CheckoutComponent_tsickle_Closure_declarations() {
/** @type {?} */
CheckoutComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CheckoutComponent.ctorParameters;
/** @type {?} */
CheckoutComponent.prototype.salesTaxRate;
/** @type {?} */
CheckoutComponent.prototype.countyChanges;
/** @type {?} */
CheckoutComponent.prototype.countyControl;
/** @type {?} */
CheckoutComponent.prototype.selectedState;
/** @type {?} */
CheckoutComponent.prototype.stateSelectElement;
/** @type {?} */
CheckoutComponent.prototype.stateSelectElementChanges;
/** @type {?} */
CheckoutComponent.prototype.states;
/** @type {?} */
CheckoutComponent.prototype.counties;
/** @type {?} */
CheckoutComponent.prototype.validationErrors;
/** @type {?} */
CheckoutComponent.prototype.cartService;
/** @type {?} */
CheckoutComponent.prototype.location;
/** @type {?} */
CheckoutComponent.prototype.checkoutService;
/** @type {?} */
CheckoutComponent.prototype.salesTaxService;
/** @type {?} */
CheckoutComponent.prototype.statesService;
/** @type {?} */
CheckoutComponent.prototype.router;
/** @type {?} */
CheckoutComponent.prototype.orderConfirmationService;
/** @type {?} */
CheckoutComponent.prototype.zone;
/** @type {?} */
CheckoutComponent.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
